import {Component} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from "@angular/forms";
import {password} from "../../constants/validation.constants";
import {CommonService} from "../../services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../state/app.state";
import {UpdatePasswordRequest} from "../../core/shared.actions";

@Component({
  selector: 'app-update-password-form',
  templateUrl: './update-password-form.component.html',
  styleUrls: ['./update-password-form.component.css']
})
export class UpdatePasswordFormComponent {


  errorMessages: any = {};
  errorMessageMap = {
    currentPassword: {
      required: 'This field is required.',
    },
    newPassword: {
      required: 'This field is required.',
      minlength: `Password must contain at least ${password.length.min} characters`,
      maxlength: `Password must contain only ${password.length.max} characters`,
      lowerCaseCheckFailed: 'Password must contain at least 1 Lowercase character',
      upperCaseCheckFailed: 'Password must contain at least 1 Uppercase character',
      numberCheckFailed: 'Password must contain at least 1 numeric character',
      specialCharCheckFailed: 'Password must contain a Special character',
      containsSpaceCheckFailed: 'Password Cannot start with or contain space in between',
    },
    confirmNewPassword: {
      required: 'This field is required.',
      passwordMatchFailed: 'Passwords do NOT match..'
    }
  }

  form = new FormGroup({
    currentPassword: new FormControl('', {
      validators: [
        Validators.required
      ],
    }),
    newPassword: new FormControl('', {
      validators: [
        Validators.required,
        Validators.minLength(password.length.min),
        Validators.maxLength(password.length.max),
        this.commonService.validatePassword
      ],
    }),
    confirmNewPassword: new FormControl('', {
      validators: [
        Validators.required,
      ],
    })
  }, {validators: [this.validateConfirmPassword]});

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
  ) {
  }


  updatePassword() {
    if (this.form.invalid) {
      this.checkForErrors()
      return
    }
    const {currentPassword: currentPassword, newPassword, confirmNewPassword} = this.form.getRawValue();
    const payload = {
      currentPassword,
      newPassword,
      confirmPassword: confirmNewPassword
    };
    this.store.dispatch(UpdatePasswordRequest({payload}))
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  validateConfirmPassword(control: AbstractControl): ValidationErrors | null {
    if (control && control.get('newPassword') && control.get('confirmNewPassword')) {
      const newPassword = control.get('newPassword').value;
      const confirmNewPassword = control.get('confirmNewPassword')?.value;

      if (newPassword && confirmNewPassword && newPassword !== confirmNewPassword) {
        control.get('confirmNewPassword').setErrors({
          ...(control.get('confirmNewPassword').errors ? control.get('confirmNewPassword').errors : {}),
          passwordMatchFailed: true
        })
      }
    }
    return null;
  }
}
